import { gql } from "@apollo/client";

export const GET_PROPERTY_CHOICE = gql`
mutation PropertyChoice($payload: PropertyChoiceDto!) {
    propertyChoice(payload: $payload)
  }
`

